import React, { useState } from "react";
import "./BookTable.css";
import { useNavigate } from "react-router-dom";
import bookTableImg from "../assets/book-table.jpg";

function BookTablePage() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [dateType, setDateType] = useState("text");

  const [formData, setFormData] = useState({
    seats: "",
    date: "",
    time: "",
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    specialRequest: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const generateTimeOptions = () => {
    const options = [];
    const startHour = 13;
    const endHour = 21;

    for (let hour = startHour; hour <= endHour; hour++) {
      for (let minutes = 0; minutes < 60; minutes += 15) {
        const timeString = new Date(0, 0, 0, hour, minutes).toLocaleTimeString(
          [],
          { hour: "2-digit", minute: "2-digit", hour12: true }
        );
        options.push(timeString);
      }
    }
    return options;
  };

  const handleDateFocus = () => setDateType("date");
  const handleDateBlur = (e) => {
    if (!e.target.value) {
      setDateType("text");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const message =
      `*New Table Booking*\n\n` +
      `*Name:* ${formData.firstName} ${formData.lastName}\n` +
      `*Phone:* ${formData.phone}\n` +
      `*Email:* ${formData.email}\n` +
      `*Seats:* ${formData.seats}\n` +
      `*Date:* ${formData.date}\n` +
      `*Time:* ${formData.time}\n` +
      `*Special Request:* ${formData.specialRequest || "None"}`;

    const encodedMessage = encodeURIComponent(message);
    const whatsappURL = `https://wa.me/447368325136?text=${encodedMessage}`;

    const isMobile = /iPhone|Android|iPad|iPod|Windows Phone/i.test(
      navigator.userAgent
    );
    const isDesktopWithWhatsAppWeb =
      /Chrome|Firefox|Edge|Safari/i.test(navigator.userAgent) &&
      window.innerWidth > 768;

    if (isMobile || isDesktopWithWhatsAppWeb) {
      window.open(whatsappURL, "_blank");
    } else {
      alert(
        "Unable to open WhatsApp. Please use a device with WhatsApp installed or contact us directly to book your table."
      );
    }
  };

  const SpinnerOverlay = () => (
    <div className="spinner-overlay">
      <div className="spinner"></div>
    </div>
  );

  return (
    <div className="booktable-container page-container">
      {isLoading && <SpinnerOverlay />}

      <div className="booking-wrapper">
        <h2 className="title">Book a Table at LKO</h2>

        <img src={bookTableImg} alt="Reserved" className="booking-banner" />

        <form className="booking-form" onSubmit={handleSubmit}>
          <input
            type="number"
            name="seats"
            placeholder="Number of seats"
            value={formData.seats}
            onChange={handleChange}
            required
          />

          <input
            type={dateType}
            name="date"
            value={formData.date}
            min={new Date().toISOString().split("T")[0]}
            onChange={handleChange}
            placeholder="Select Date"
            onFocus={handleDateFocus}
            onBlur={handleDateBlur}
            required
          />

          <select
            id="time"
            name="time"
            value={formData.time}
            onChange={handleChange}
            style={{ color: formData.time === "" ? "#777777" : "#000" }}
            required
          >
            <option value="">Select time</option>
            {generateTimeOptions().map((timeOption, index) => (
              <option key={index} value={timeOption}>
                {timeOption}
              </option>
            ))}
          </select>

          <input
            type="text"
            name="firstName"
            placeholder="First name"
            value={formData.firstName}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="lastName"
            placeholder="Last name"
            value={formData.lastName}
            onChange={handleChange}
            required
          />

          <input
            type="tel"
            name="phone"
            placeholder="Phone number"
            value={formData.phone}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Email address"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <textarea
            name="specialRequest"
            placeholder="Special request"
            rows={3}
            value={formData.specialRequest}
            onChange={handleChange}
          />

          <button
            type="submit"
            class="cta-button primary-btn post-review-btn book-btn"
          >
            Book Now
          </button>
        </form>
      </div>
    </div>
  );
}

export default BookTablePage;
